// extracted by mini-css-extract-plugin
module.exports = {"OrderAddress":"OrderAddress_OrderAddress__1p9vc","OrderAddress__name":"OrderAddress_OrderAddress__name__2MGTw"};